import { combineReducers } from 'redux';
import { SET_MODBUS_TEMPLATES } from '../actions/actiontypes';

const templates = (state = {}, action) => {
  if (action.type !== SET_MODBUS_TEMPLATES) return state;
  return action.data;
};

const modbusReducer = combineReducers({
  templates,
});

export default modbusReducer;
